import { CheckIndexedDBIsSupport } from "../../IndexedDB/tabIndexedDB";
import { CheckBroadcastIsSupport } from "../../broadcastChannel/tabChannel";
import {
  BroadcastAuthenticatedNotificationStatus,
  BroadcastIsUpdateNotificationCount,
  BroadcastIsUpdateNotificationList,
} from "../../broadcastChannel/userChannel";
import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import {
  ClearTimerCheckAccessToken,
  DoAddNotificationCount,
  DoAddReadNotificationList,
  DoAddUnreadNotificationList,
  DoDeleteNotificationByIdFromEmit,
  DoGetNotificationCount,
  DoGetReadAllNotificationList,
  DoGetUnreadAllNotificationList,
  SetIsSeenForNotification,
  SetTimerCheckAccessToken,
  SocketAuthentication,
  SortDataNotification,
} from "../../helper/notificationHelper";
export const mutations = {
  SOCKET_authenticated(state, payload) {
    if (payload) {
      state.notificationIsAuthenticated = true;
      state.notificationReadyToUse = true;
      SetTimerCheckAccessToken();
      BroadcastAuthenticatedNotificationStatus(Enums.AuthenticatedNotification.Success);
    } else {
      state.notificationReadyToUse = false;
      BroadcastAuthenticatedNotificationStatus(Enums.AuthenticatedNotification.Failed);
    }
  },
  SOCKET_connect(state) {
    state.notificationIsConnect = true;
    SocketAuthentication();
  },
  SOCKET_disconnect(state) {
    state.notificationReadyToUse = false;
    state.notificationIsConnect = false;
    state.notificationIsAuthenticated = false;
    ClearTimerCheckAccessToken();
  },
  async SOCKET_GetNotificationCount(state, payload) {
    state.notificationCountLoadingStatus = Enums.LoadingStatusType.Loading;

    let merchantId = userInfo.MerchantId();
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoAddNotificationCount(payload.merchantId, payload.notificationCount);
      if (payload.merchantId == merchantId) {
        state.notificationCount = await DoGetNotificationCount(merchantId);
      }
    } else {
      state.notificationCount = payload.notificationCount;
    }
    setTimeout(() => {
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        BroadcastIsUpdateNotificationCount(payload.merchantId);
      }
      state.notificationCountLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },
  async SOCKET_RemoveNotificationById(state, payload) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoDeleteNotificationByIdFromEmit(payload.merchantId, payload.notificationId);
    } else {
      state.notificationList = state.notificationList.filter((x) => x.id !== payload.notificationId);
    }
  },

  async MutationGetNotificationCount(state, payload) {
    state.notificationCountLoadingStatus = Enums.LoadingStatusType.Loading;

    let merchantId = userInfo.MerchantId();
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoAddNotificationCount(payload.merchantId, payload.notificationCount);
      if (payload.merchantId == merchantId) {
        state.notificationCount = await DoGetNotificationCount(merchantId);
      }
    } else {
      state.notificationCount = payload.notificationCount;
    }
    setTimeout(() => {
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        BroadcastIsUpdateNotificationCount(payload.merchantId);
      }
      state.notificationCountLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  async MutationGetAllNotificationList(state, payload) {
    state.notificationListLoadingStatus = Enums.LoadingStatusType.Loading;
    const merchantId = userInfo.MerchantId();
    state.notificationList = [];
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoAddUnreadNotificationList(payload.merchantId, payload.unreadNotificationList);
      await DoAddReadNotificationList(payload.merchantId, payload.readNotificationList);
      if (payload.merchantId == merchantId) {
        const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
        const readNotificationList = await DoGetReadAllNotificationList(merchantId);
        const notificationList = [
          ...SetIsSeenForNotification(unreadNotificationList, false),
          ...SetIsSeenForNotification(readNotificationList, true),
        ];
        state.notificationList = SortDataNotification(notificationList);
      }
    } else {
      const notificationList = [
        ...SetIsSeenForNotification(payload.unreadNotificationList, false),
        ...SetIsSeenForNotification(payload.readNotificationList, true),
      ];
      state.notificationList = SortDataNotification(notificationList);
    }

    setTimeout(() => {
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        BroadcastIsUpdateNotificationList(payload.merchantId);
      }
      state.notificationListLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  MutationSetNotificationListLoadingStatus(state, status) {
    state.notificationListLoadingStatus = status;
  },

  MutationSetNotificationReadyToUse(state, status) {
    state.notificationReadyToUse = status;
  },

  async MutationSetNotificationListFromIndexedDB(state) {
    state.notificationListLoadingStatus = Enums.LoadingStatusType.Loading;
    let merchantId = userInfo.MerchantId();
    state.notificationList = [];
    const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    const readNotificationList = await DoGetReadAllNotificationList(merchantId);
    const notificationList = [
      ...SetIsSeenForNotification(unreadNotificationList, false),
      ...SetIsSeenForNotification(readNotificationList, true),
    ];
    state.notificationList = SortDataNotification(notificationList);

    setTimeout(() => {
      state.notificationListLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  async MutationSetNotificationCountFromIndexedDB(state) {
    state.notificationCountLoadingStatus = Enums.LoadingStatusType.Loading;
    let merchantId = userInfo.MerchantId();
    state.notificationCount = await DoGetNotificationCount(merchantId);
    setTimeout(() => {
      state.notificationCountLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },
};
